import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { getConfig } from '@cian/config/browser';
import { getLogger } from '@cian/logger/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { App } from '../../shared/containers/app/app';
import { Home } from '../../shared/containers/HomeContainer';
import { ApplicationContext } from '../../shared/reactContext/applicationContext';
import { IApplicationContext } from '../../shared/types/application';
import { IReduxStore } from '../../shared/types/redux';

export const renderApplication = (store: IReduxStore) => {
  const applicationContext: IApplicationContext = {
    logger: getLogger(),
    config: getConfig(),
    httpApi: getHttpApi(),
  };

  ReactDOM.hydrate(
    <ApplicationContext.Provider value={applicationContext}>
      <Provider store={store} key="provider">
        <App store={store}>
          <Home section={window.__mainpage_section__} />
        </App>
      </Provider>
    </ApplicationContext.Provider>,
    // TODO: не приводить тип
    document.getElementById('mainpage') as Element,
  );
};
